import React, { useRef, useEffect, useState } from "react";
import $ from "jquery";
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import { showMessage, showErrorMessage } from "../common/Utils";
import { login } from "../../api/apiHandler";
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie';
import { useAuth } from "../../context/AuthContext";

export function Login() {

    let loginFormRef = useRef(null);
    const { isAuthenticated, refreshProfile } = useAuth();

    const [showPassword, setShowPassword] = useState(false);
    const [timezone, setTimezone] = useState('');
    const [formData, setFormData] = useState({
        email: '',
        remember: false,
    });

    let navigate = useNavigate();

    // Redirect to dashboard if already logged in
    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard');
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {

        const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        console.log('User Timezone:', userTimezone);
        setTimezone(userTimezone);
        // Initialize the parsley plugin
        $(loginFormRef.current).parsley();

        // Check for stored cookies and set the form data
        const storedEmail = Cookies.get('email');
        const remember = Cookies.get('remember') === 'true';
        if (storedEmail && remember) {
            setFormData({
                email: storedEmail,
                remember: remember,
            });
        }
    }, []);

    const handleLoginRequest = async(e) => {
        e.preventDefault();

        if ($(loginFormRef.current).parsley().isValid()) {

            // Save the email in a cookie if "Remember me" is checked (never the password)
            if (loginFormRef.current.remember.checked) {
                Cookies.set('email', loginFormRef.current.email.value, { expires: 15 });
                Cookies.set('remember', loginFormRef.current.remember.checked, { expires: 15 });
            } else {
                Cookies.remove('email');
                Cookies.remove('remember');
            }

            const loginReq = {
                user_type: 1,
                device_type: 2,
                email: loginFormRef.current.email.value,
                password: loginFormRef.current.password.value,
                timezone: timezone
            }
            const response = await login(loginReq);
            if (parseInt(response.code) === 1) {
                await refreshProfile();
                navigate('/dashboard');
            } else {
                showErrorMessage(response.message);
            }
        } else {
            showErrorMessage("Something went wrong, some required fields are missing");
        }
    };

    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };
    return (
        <>
            <div className="authentication">
                <div className="card">
                    <div className="body">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="header slideDown">
                                    <div className="logo">
                                        <img src={process.env.PUBLIC_URL + "/logo_black.png"} alt="Images" style={{ height: '60px', width: '175px' }} />
                                    </div>
                                    <h1 className="mt-3">Admin portal</h1>
                                </div>
                            </div>
                            <form className="col-lg-12" id="sign_in" ref={loginFormRef} onSubmit={handleLoginRequest}>
                                <h5 className="title">Sign in to your account</h5>
                                <div className="form-group form-float">
                                    <div className="form-line">
                                        <input 
                                            className="form-control" 
                                            id="email"
                                            name="email"
                                            placeholder="Email address"
                                            data-parsley-required="true"
                                            data-parsley-type="email"
                                            data-parsley-required-message="Please enter email address"
                                            data-parsley-type-message="Please enter valid email address"
                                            data-parsley-errors-container="#loginEmailError"
                                            defaultValue={formData.email} 
                                        />
                                    </div>
                                    <span id="loginEmailError"></span>
                                </div>
                                <div className="form-group form-float">
                                    <div className="form-line">
                                        <input 
                                            className="form-control" 
                                            id="password-field"
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            placeholder="Enter password"
                                            data-parsley-required="true"
                                            data-parsley-minlength="6"
                                            data-parsley-required-message="Please enter password"
                                            data-parsley-minlength-message="Please enter atleast 6 characters"
                                            data-parsley-errors-container="#loginPasswordError"
                                        />
                                        <i 
                                        className={`zmdi ${showPassword ? 'zmdi-eye-off' : 'zmdi-eye'}`}
                                        onClick={togglePassword}
                                        style={{
                                            position: 'absolute',
                                            right: '15px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer',
                                            fontSize: '20px',
                                            color: '#666'
                                        }}
                                        ></i>
                                    </div>
                                    <span id="loginPasswordError"></span>
                                </div>
                                <div>
                                    <input
                                        type="checkbox"
                                        className="filled-in chk-col-cyan"
                                        id="remember"
                                        name="remember"
                                        checked={formData.remember}
                                        onChange={(e) => setFormData((prev) => ({ ...prev, remember: e.target.checked }))}
                                    />
                                    <label htmlFor="remember">Remember me</label>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <button type="submit" className="btn btn-raised btn-primary waves-effect">
                                        SIGN IN
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}